import React from "react";
import { UserDetailSection } from "../components/UserDetailSection";
import { getInternalSections, Section } from "UserAdmin/components/permissions/permissionsectioncreator";
import { PermissionGroup } from "UserAdmin/components/permissions/PermissionGroup";
import { LinkedArtistUserPanel } from "components/linkedArtists/LinkedArtistUser";
import { LinkedBookkeepingsUserPanel } from "components/linkedBookkeepings/LinkedBookkeepingsUser";

interface Props {
  clientConfig: server.dto.ClientConfiguration
  userToClient: server.dto.UserForInternalAdmin
  onNameChanged: (firstName: string, lastName: string) => void;
}

interface UserForInternalState {
  permissions: server.dto.InternalEnvironmentPermissions;
}

export const UserForInternalDetailSection = (props: Props) => {
  const [state, setState] = React.useState<UserForInternalState>({
    permissions: props.userToClient.areaPermissions,
  });

  const onValueChanged = (key: string, value: any) => {
    if (key.startsWith("permissions")) {
      setState(prevState => ({
        ...prevState,
        permissions: value
      }));
    }
  };

  const sections = getInternalSections(props.clientConfig, state.permissions) as Array<Section<server.dto.InternalEnvironmentPermissions | server.dto.ExternalEnvironmentPermissions>>

  return <UserDetailSection
    userToClient={props.userToClient}
    environment="internal"
    title={RESX.UserType.InternalUser}
    updateFunc={window.CoreApi.UserForInternalAdmin.Update}
    onValueChanged={onValueChanged}
    onNameChanged={props.onNameChanged}
    additionalSections={[{
      key: "permissions",
      type: "regular",
      title: RESX.SoUser.Permissions,
      supportArticleId: serverReference.supportArticleIds.internalUserPermissions,
      fields: sections.filter(section => section.isVisible).map(section => ({
        key: `permissions-${section.label}`,
        label: section.label,
        hideLabel: true,
        render: () => <PermissionGroup
          readonly
          userToClientId={props.userToClient.userToClientId}
          userId={props.userToClient.user.userId}
          permissions={state.permissions}
          permissionGroup={section}
          onChange={() => { }}
        />,
        inPageEdit: {
          render: ({ value, onChange }) => <div className="main-section-template-fields-padding">
            <PermissionGroup
              userToClientId={props.userToClient.userToClientId}
              userId={props.userToClient.user.userId}
              permissions={value}
              permissionGroup={getInternalSections(props.clientConfig, value).find(s => s.label === section.label) as Section<server.dto.InternalEnvironmentPermissions | server.dto.ExternalEnvironmentPermissions>}
              onChange={onChange}
            />
          </div>,
          fullWidth: true,
          type: "confirmOrCancelButton",
          initialValue: state.permissions,
          submitChange: (permissions: server.dto.InternalEnvironmentPermissions) => window.CoreApi.UserForInternalAdmin.UpdatePermissions({
            userToClientId: props.userToClient.userToClientId,
            permissions,
          })
        }
      }))
    }, {
      key: "artists",
      type: "custom",
      render: () => <LinkedArtistUserPanel
        key="artists"
        environment="internal"
        userToClientId={props.userToClient.userToClientId}
      />
    }, {
      key: "bookkeepings",
      type: "custom",
      render: () => <LinkedBookkeepingsUserPanel
        key="bookkeepings"
        userToClientId={props.userToClient.userToClientId}
      />
    }]}
  />
}